import { useLocation } from 'react-router-dom';

import { Navigate } from './Navigate';

type Props = {
  to: string;
};

/**
 * Like `<Navigate>` but preserves `location.search` and `location.hash` on
 * redirect. Use this for redirects where the destination is a fixed pathname
 * but query params and hash fragments must survive (e.g. deep-link params,
 * bookmark anchors).
 */
export const NavigatePreservingSearch = ({ to }: Props) => {
  const location = useLocation();

  return (
    <Navigate
      to={{
        pathname: to,
        search: location.search,
        hash: location.hash,
      }}
    />
  );
};
